import * as types from './mutation-types'
const mutations = {
    userInfo(state, data) { //存入个人信息
        state.userInfo = data
    },
    cartNum(state) {
        state.cartNum = localStorage.getItem('cartNum') ? localStorage.getItem('cartNum') : 0
    },
    cartList(state, data) {
        state.cartList = data
    }

}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js